import {Component, OnInit, Input} from '@angular/core';
import {NgbActiveModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';
import { SharedService } from '../../services/SharedService.service';

@Component({
    selector: 'app-save-template',
    templateUrl: './save-template.component.html',
    styleUrls: ['./save-template.component.scss'],
    providers: []
})
export class SaveTemplateComponent implements OnInit {

    @Input() params;
    @Input() screenName;
    modalRef: NgbModalRef;
    form: FormGroup;

    constructor(public activeModal: NgbActiveModal,
                public translate: TranslateService,
                private sharedservice: SharedService,
                private formBuilder: FormBuilder,
                private modalService: NgbModal,) {
    }

    ngOnInit() {

      this.form = this.formBuilder.group({
        name: new FormControl('', Validators.required)
      });
    }

  onSubmit() {
      if (this.form.valid) {
        const formdata = {
          'params':this.params,
          'screen':this.screenName,
          'name':this.form.controls['name'].value
        };

        this.sharedservice.saveSearchTemplate(formdata).subscribe(
            search => {
              this.close();
            }
        );


      }
    }

    close() {
        this.activeModal.dismiss('done');
    }

}



// WEBPACK FOOTER //
// ./src/app/components/save-template/save-template.component.ts